import React from "react";
import PropTypes from "prop-types";

import QueryResults from "components/Common/QueryResults";
import UserSampleTable from "components/Common/UserSampleTable";

export const RecentUsersTable = ({ results }) => {
  const userSample = {
    meta: {
      fetching: false,
      synced: !!results,
      errored: false
    },
    data: results
  };

  return (
    <UserSampleTable
      title="10 Most Recent Users"
      userSample={userSample}
      timestampHeader="Flow Seen"
    />
  );
};

RecentUsersTable.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      user_id: PropTypes.string,
      timestamp: PropTypes.string
    })
  )
};

const RecentUsersTableWithAnalytics = ({ flowId, startTime }) => (
  <QueryResults
    query={{
      conditions: [
        ["flow_id", "==", flowId],
        ["name", "==", "appcues:flow_started"]
      ],
      dimensions: ["user_id", "timestamp"],
      order_by: [["timestamp", "desc"]],
      start_time: startTime,
      limit: 10
    }}
  >
    {results => <RecentUsersTable results={results} startTime={startTime} />}
  </QueryResults>
);

RecentUsersTableWithAnalytics.propTypes = {
  flowId: PropTypes.string,
  startTime: PropTypes.string
};

export default RecentUsersTableWithAnalytics;
